import React from "react";
import { Outlet } from "react-router-dom";
import AppSidebar from "../components/layout/AppSidebar";
import AppFooter from "../components/layout/AppFooter";

/**
 * Layout for every signed-in route: sidebar on the left, content and footer
 * filling the rest. `RequireAuth` wraps this at the route level, so nothing
 * here needs to check auth itself.
 */
export default function AppShell() {
  return (
    <div className="flex min-h-screen bg-paper lg:flex-row">
      <AppSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <main className="flex-1">
          <Outlet />
        </main>
        <AppFooter />
      </div>
    </div>
  );
}
